import {SelectId} from "./SelectId";
import React from "react";
import {Select} from "./Select";

const PBSOptions = [{ label: 'Empty (no firm or pencil bookings)', id: 'empty' },
    { label: 'Part Pencil (only pencil bookings but less than panel capacity)', id: 'pencil_partial' },
    { label: 'Full Pencil (only pencil bookings, including those at panel capacity)', id: 'pencil_full' },
    { label: 'Panels with space available for bookings', id: 'some_free_with_pencil' },
    { label: 'Panels with space available for bookings (including pencil)', id: 'some_free' }
];

export const PanelBookingStatusSelect = (props) => {
    return props.valueIsId?<SelectId options={PBSOptions} {...props} labelField="label" />:<Select options={PBSOptions} {...props} labelField="label" />
}
